import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "./Seo";
import { services } from "../data/services";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page not found | Cambridge Carpenter"
        description="The page you were looking for could not be found."
        canonical="https://www.cambridgecarpenter.co.uk/404/"
        noindex
      />
      <div className="max-w-site mx-auto px-5 sm:px-10 pt-32 pb-24 text-center min-h-[60vh] flex flex-col items-center justify-center">
        <p className="eyebrow eyebrow--center mb-5">Error 404</p>
        <h1 className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl text-ink leading-tight">
          We couldn’t find that page
        </h1>
        <p className="text-bark text-lg leading-7 mt-5 max-w-xl">
          The page may have moved or no longer exists. Head back home or jump straight to one of our services.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          <Link to="/" className="btn-primary">Back to home</Link>
          <Link to="/contact" className="btn-outline">Contact us</Link>
        </div>
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mt-12 text-oak">
          {services.map((s) => (
            <Link key={s.slug} to={`/carpentry-services/${s.slug}`} className="underline underline-offset-4 hover:text-oak-dark">
              {s.navLabel}
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
